<template>
  <div class="BottomNavigation">
    <div class="BottomNavigation-tabs">
      <template v-for="(item, index) in tabs">
        <div :key="index" class="box" @click="tabsClick(item)">
          <div class="box-item">{{ item.title }}</div>
          <div class="box-item1" v-show="item.in"></div>
        </div>
      </template>
    </div>
    <div class="box-text" >
      <a href="https://beian.miit.gov.cn/" target="_blank" style="color:#000;text-decoration: none; " class="link">{{
        SettingList.web_icp
      }}</a>
      <span class="boxxxx">版权所有&#169;{{SettingList.copyright}}</span>
      <span class="boxxxx">联系我们：{{SettingList.company_tel}}</span>
    </div>
  </div>
</template>

<script>
import { corporateSettingApi } from "@/api/toolApi";
export default {
  name: "BottomNavigation",
  data() {
    return {
      SettingList: [],
      tabs: [
        {
          title: "首页",
          in: false,
          route: "/",
          rou: [
            "/",
            "/recharge",
            "/rechargeS",
            "/SearchDetails",
            "/chatGpt",
            "/advancedSearch",
          ],
        },
        {
          title: "产业服务",
          in: false,
          route: "/industrialService",
          rou: ["/industrialService"],
        },
        {
          title: "会员福利",
          in: false,
          route: "/VIP",
          rou: ["/VIP"],
        },
        {
          title: "个人中心",
          in: false,
          route: "/personalCenter",
          rou: ["/personalCenter"],
        },
      ],
    };
  },
  mounted() {
    this.corporateSettingList();
    let route = this.$route.path;
    this.tabs.forEach((item) => {
      item.in = false;
      let st = null;
      if (item.rou) {
        st = item.rou.findIndex((ite) => ite == route);
        if (st !== -1) {
          item.in = true;
        }
      } else {
        console.log(11);
      }
    });
  },
  methods: {
    
    tabsClick(item) {
      console.log(item);
      let token = localStorage.getItem("token");
      if(token){
        this.$router.push(item.route);
      }else if(item.route == '/personalCenter' || item.route == '/VIP'){
        this.$confirm("您还未登录，是否需要登录?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.$router.push("/login");
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消",
          });
          this.$router.push("/");
        });
      }else{
        this.$router.push(item.route);
      }
    },
    corporateSettingList() {
      if (sessionStorage.getItem("SettingList")) {
        let ct = JSON.parse(sessionStorage.getItem("SettingList"));
        this.SettingList = ct;
        return;
      }
      corporateSettingApi({}).then((res) => {
        console.log(res);
        if (res.code == 0) {
          this.SettingList = res.data;
          sessionStorage.setItem("SettingList", JSON.stringify(res.data));
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.link{
  font-size: 14px;
}
.boxxxx{
  margin-left: 10px;
  font-size: 14px;
}
.box-text {
  width: 100%;
  margin: 0 auto;
  height: 12px;
  font-family: Source Han Sans CN, Source Han Sans CN;
  font-weight: 400;
  font-size: 12px;
  color: #000;
  line-height: 12px;
  text-align: center;
  font-style: normal;
  text-transform: none;
  text-decoration: none;
}
.BottomNavigation {
  width: 100%;
  height: 10vh;
  position: fixed;
  z-index: 99;
  bottom: 0;
  left: 0;
  .BottomNavigation-tabs {
    width: 100%;
    height: 48px;
    display: flex;
    justify-content: flex-end;
    margin-top: 10px;
  }
  .box {
    display: flex;
    flex-direction: column;
    margin-right: 52px;
    cursor: pointer;

    .box-item {
      height: 16px;
      font-family: Source Han Sans CN, Source Han Sans CN;
      font-weight: bold;
      font-size: 16px;
      color: #000000;
      line-height: 16px;
      text-align: left;
      font-style: normal;
      text-transform: none;
      margin-bottom: 6px;
    }
    .box-item1 {
      width: 100%;
      height: 4px;
      background: linear-gradient(90deg, #4834d4 0%, rgba(72, 52, 212, 0) 100%);
      border-radius: 0px 0px 0px 0px;
    }
  }
}
</style>